import React, { FunctionComponent } from 'react';

import { Skeleton } from '@yandex-360/orb-components/dist/components/Skeleton';

import styles from './styles.css';

export const NextBatchLoadingSkeleton: FunctionComponent = () => {
    return (
        <div className={styles.batchLoadingSkeleton}>
            <Skeleton width="var(--conferences-history-date-range-skeleton-width)" height="var(--orb-size-16-m)" />
            <Skeleton width="100%" height="var(--orb-size-40-m)" />
            <Skeleton width="100%" height="var(--orb-size-40-m)" />
            <Skeleton width="100%" height="var(--orb-size-40-m)" />
            <Skeleton width="100%" height="var(--orb-size-40-m)" />
        </div>
    );
};
